var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tabs',{directives:[{name:"decorator",rawName:"v-decorator",value:(['tags', {
    }]),expression:"['tags', {\n    }]"}],attrs:{"type":"card"}},[_c('a-tab-pane',{key:"basic",attrs:{"tab":"项目汇总"}},[_c('project-summary',{ref:"child",attrs:{"id":_vm.id}})],1),_c('a-tab-pane',{key:"family",attrs:{"tab":"订购记录"}},[_c('order-record',{ref:"child",attrs:{"id":_vm.id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }